<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <div>Merchant test</div>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div v-if="mData.entryMode === 'gate'" class="entry-gate">
          <h5 class="step-title">Chọn cách truy cập</h5>
          <b-row class="justify-content-center">
            <b-col md="4">
              <div
                class="method-block"
                :class="{ 'is-active': mData.gateChoice === 'account' }"
                @click="fn_selectGate('account')"
              >
                <i class="method-icon el-icon-user"></i>
                <div class="method-name">Tài khoản đăng nhập</div>
                <div class="method-desc">Đăng nhập bằng tài khoản của bạn</div>
              </div>
            </b-col>
            <b-col md="4">
              <div
                class="method-block"
                :class="{ 'is-active': mData.gateChoice === 'guest' }"
                @click="fn_selectGate('guest')"
              >
                <i class="method-icon el-icon-right"></i>
                <div class="method-name">Tài khoản khách</div>
                <div class="method-desc">Tiếp tục mà không cần đăng nhập</div>
              </div>
            </b-col>
          </b-row>

          <b-row
            v-if="mData.gateChoice === 'account'"
            class="justify-content-center login-form-row"
          >
            <b-col md="8">
              <div class="login-form-wrap">
            <el-form
              :model="mData.loginForm"
              :rules="mData.loginRules"
              ref="loginForm"
              label-position="top"
            >
              <el-form-item label="Tài khoản" prop="account">
                <el-input
                  v-model="mData.loginForm.account"
                  placeholder="Nhập tài khoản"
                  clearable
                  @keyup.enter.native="fn_login"
                ></el-input>
              </el-form-item>
              <el-form-item label="Mật khẩu" prop="password">
                <el-input
                  v-model="mData.loginForm.password"
                  type="password"
                  placeholder="Nhập mật khẩu"
                  show-password
                  @keyup.enter.native="fn_login"
                ></el-input>
              </el-form-item>
              <el-form-item class="text-center">
                <el-button
                  type="primary"
                  :loading="mData.loggingIn"
                  @click="fn_login"
                >
                  Đăng nhập
                </el-button>
              </el-form-item>
            </el-form>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-if="mData.entryMode === 'wizard'" class="steps-scroll-area">
        <div v-if="mData.activeStep === 0" class="step-content">
          <div class="step2-header">
            <h5 class="step2-title">Chọn cổng thanh toán</h5>
            <div class="step2-actions">
              <el-button @click="fn_backToGate">Quay lại</el-button>
              <el-button
                type="primary"
                :disabled="!isPaygateSelected"
                @click="fn_nextStep"
              >
                Tiếp theo
              </el-button>
            </div>
          </div>

          <div class="step2-block" v-loading="mData.loadingPaygate">
            <div class="block-title">Danh sách cổng thanh toán</div>

            <div class="merchant-code-row">
              <el-input
                v-model="mData.merchantCode"
                placeholder="Nhập mã merchant (code)"
                clearable
                class="merchant-code-input"
                @keyup.enter.native="fn_getPaygateList"
                @clear="fn_clearPaygateList"
              ></el-input>
              <el-button
                type="primary"
                :disabled="!mData.merchantCode"
                class="merchant-code-btn"
                @click="fn_getPaygateList"
              >
                Tải danh sách
              </el-button>
            </div>

            <el-radio-group
              v-if="mData.paygateList.length"
              v-model="mData.selectedPaygateId"
              class="paygate-list"
            >
              <el-radio
                v-for="item in mData.paygateList"
                :key="item.id"
                :label="item.id"
                class="paygate-item"
              >
                <el-tag
                  v-if="item.method"
                  size="mini"
                  type="info"
                  class="paygate-method-tag"
                >
                  {{ item.method.toUpperCase() }}
                </el-tag>
                <span class="paygate-code">{{ item.code }}</span>
                <span class="paygate-name">{{ item.name }}</span>
              </el-radio>
            </el-radio-group>

            <div v-else-if="mData.paygateLoaded" class="paygate-empty">
              <i class="el-icon-document-remove"></i>
              <div>Chưa có thông tin cổng thanh toán</div>
            </div>

            <div v-else class="paygate-empty">
              <i class="el-icon-search"></i>
              <div>Nhập mã merchant và bấm "Tải danh sách".</div>
            </div>
          </div>
        </div>

        <!-- Luồng API (activeStep === 1) -->
        <!-- Luồng QR/API (activeStep === 1): form order + signature -->
        <div v-if="mData.activeStep === 1" class="step2-content">
          <div class="step2-header">
            <h5 class="step2-title">
              <template v-if="mData.showSignatureStep">Tạo Signature</template>
              <template v-else-if="mData.showPurchaseStep">
                Thông tin purchase
              </template>
              <template v-else-if="mData.showPaymentUrlStep">
                Thông tin tạo payment url
              </template>
              <template v-else>Thông tin order</template>
            </h5>
            <div class="step2-actions">
              <el-button @click="fn_prevStep">Quay lại</el-button>
              <el-button
                v-if="
                  !mData.showSignatureStep &&
                  !mData.showPurchaseStep &&
                  !mData.showPaymentUrlStep
                "
                type="primary"
                :loading="mData.creatingOrder"
                @click="fn_nextStep"
              >
                Tiếp theo
              </el-button>
              <el-button
                v-else-if="mData.showSignatureStep"
                type="primary"
                :loading="mData.creatingQr"
                @click="fn_submitSignature"
              >
                Tạo &amp; Tiếp tục
              </el-button>
              <el-button
                v-else-if="mData.showPurchaseStep"
                type="primary"
                :loading="mData.callingPurchase"
                @click="fn_submitPurchase"
              >
                Gọi Purchase
              </el-button>
              <el-button
                v-else
                type="primary"
                :loading="mData.callingPaymentUrl"
                @click="fn_submitPaymentUrl"
              >
                Tạo Payment URL
              </el-button>
            </div>
          </div>

          <div
            v-if="
              !mData.showSignatureStep &&
              !mData.showPurchaseStep &&
              !mData.showPaymentUrlStep
            "
            class="step2-block"
          >
            <el-form
              :model="mData.orderForm"
              :rules="mData.orderRules"
              ref="orderForm"
              label-width="120px"
              label-position="top"
            >
              <el-form-item label="Order ID" prop="order_id">
                <div class="order-id-row">
                  <el-input
                    v-model="mData.orderForm.order_id"
                    placeholder="Nhập hoặc tạo tự động"
                    clearable
                    class="order-id-input"
                  ></el-input>
                  <el-button
                    type="primary"
                    plain
                    class="order-id-gen"
                    @click="fn_generateOrderId"
                  >
                    Tạo ID
                  </el-button>
                </div>
              </el-form-item>

              <el-form-item label="Amount" prop="amount">
                <el-input-number
                  v-model="mData.orderForm.amount"
                  :min="0"
                  :controls="false"
                  placeholder="Nhập số tiền"
                  class="full-width"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Message" prop="message">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="mData.orderForm.message"
                  placeholder="Mô tả order (tùy chọn)"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <div class="partner-data-header">
                  <span>Dữ liệu mở rộng</span>
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    icon="el-icon-plus"
                    @click="fn_addPartnerData"
                  >
                    Thêm
                  </el-button>
                </div>

                <div
                  v-for="(pair, index) in mData.orderForm.partner_data"
                  :key="index"
                  class="partner-data-row"
                >
                  <el-input
                    v-model="pair.key"
                    placeholder="Key (vd: ticket_code)"
                    class="partner-data-key"
                  ></el-input>
                  <el-input
                    v-model="pair.value"
                    placeholder="Value"
                    class="partner-data-value"
                  ></el-input>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    class="partner-data-remove"
                    @click="fn_removePartnerData(index)"
                  ></el-button>
                </div>

                <div
                  v-if="!mData.orderForm.partner_data.length"
                  class="partner-data-empty"
                >
                  Chưa có thông tin. Bấm "Thêm" để nhập dữ liệu.
                </div>
              </el-form-item>
            </el-form>
          </div>

          <div v-else-if="mData.showSignatureStep" class="step2-block">
            <Signature
              ref="signatureRef"
              :is-embedded="true"
              :payload="{
                merchant: mData.merchantCode,
                ref_id: mData.orderId,
                description: mData.orderForm.message || undefined,
                paygate_id: mData.selectedPaygateId || undefined,
                data: fn_buildPartnerDataObject(),
              }"
              @signature-generated="fn_onSignatureGenerated"
            />
          </div>

          <!-- Luồng API: form purchase (sau khi tạo order) -->
          <div v-else-if="mData.showPurchaseStep" class="step2-block">
            <el-form
              :model="mData.purchaseForm"
              :rules="mData.purchaseRules"
              ref="purchaseForm"
              label-position="top"
            >
              <el-form-item label="Merchant (merchant)" prop="merchant">
                <el-input
                  :value="mData.merchantCode"
                  disabled
                ></el-input>
              </el-form-item>

              <el-form-item label="Paygate" prop="paygate">
                <el-input :value="fn_getSelectedPaygateLabel()" disabled></el-input>
              </el-form-item>

              <el-form-item label="Session ID (session_id)" prop="session_id">
                <el-input
                  v-model="mData.purchaseForm.session_id"
                  placeholder="Nhập session_id (tùy chọn)"
                  clearable
                ></el-input>
              </el-form-item>

              <el-form-item label="Amount (amount)" prop="amount">
                <el-input-number
                  v-model="mData.purchaseForm.amount"
                  :min="0"
                  :controls="false"
                  placeholder="Nhập số tiền"
                  class="full-width"
                  disabled
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Description (description)" prop="description">
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="mData.purchaseForm.description"
                  placeholder="Nội dung thanh toán (tùy chọn)"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <div class="partner-data-header">
                  <span>Dữ liệu mở rộng (data)</span>
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    icon="el-icon-plus"
                    @click="fn_addPurchaseData"
                  >
                    Thêm
                  </el-button>
                </div>

                <div
                  v-for="(pair, index) in mData.purchaseForm.data_pairs"
                  :key="index"
                  class="partner-data-row"
                >
                  <el-input
                    v-model="pair.key"
                    placeholder="Key"
                    class="partner-data-key"
                  ></el-input>
                  <el-input
                    v-model="pair.value"
                    placeholder="Value"
                    class="partner-data-value"
                  ></el-input>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    class="partner-data-remove"
                    @click="fn_removePurchaseData(index)"
                  ></el-button>
                </div>

                <div
                  v-if="!mData.purchaseForm.data_pairs.length"
                  class="partner-data-empty"
                >
                  Chưa có dữ liệu. Bấm "Thêm" để nhập cặp key-value.
                </div>
              </el-form-item>
            </el-form>
          </div>

          <!-- Luồng WebView: form create_payment_url (sau khi tạo order) -->
          <div v-else class="step2-block">
            <el-form
              :model="mData.paymentUrlForm"
              :rules="mData.paymentUrlRules"
              ref="paymentUrlForm"
              label-position="top"
            >
              <el-form-item label="Merchant (merchant)" prop="merchant">
                <el-input :value="mData.merchantCode" disabled></el-input>
              </el-form-item>

              <el-form-item label="Paygate" prop="paygate">
                <el-input :value="fn_getSelectedPaygateLabel()" disabled></el-input>
              </el-form-item>

              <el-form-item label="Session ID (session_id)" prop="session_id">
                <el-input
                  v-model="mData.paymentUrlForm.session_id"
                  placeholder="Nhập session_id (tùy chọn)"
                  clearable
                ></el-input>
              </el-form-item>

              <el-form-item
                label="Original Amount (original_amount)"
                prop="original_amount"
              >
                <el-input-number
                  v-model="mData.paymentUrlForm.original_amount"
                  :min="0"
                  :controls="false"
                  placeholder="Số tiền trước giảm giá (tùy chọn)"
                  class="full-width"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Amount (amount)" prop="amount">
                <el-input-number
                  v-model="mData.paymentUrlForm.amount"
                  :min="0"
                  :controls="false"
                  placeholder="Nhập số tiền"
                  class="full-width"
                  disabled
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Description (description)" prop="description">
                <el-input
                  type="textarea"
                  :rows="2"
                  v-model="mData.paymentUrlForm.description"
                  placeholder="Nội dung thanh toán (tùy chọn)"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <div class="partner-data-header">
                  <span>Dữ liệu mở rộng (data)</span>
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    icon="el-icon-plus"
                    @click="fn_addPaymentUrlData"
                  >
                    Thêm
                  </el-button>
                </div>

                <div
                  v-for="(pair, index) in mData.paymentUrlForm.data_pairs"
                  :key="index"
                  class="partner-data-row"
                >
                  <el-input
                    v-model="pair.key"
                    placeholder="Key"
                    class="partner-data-key"
                  ></el-input>
                  <el-input
                    v-model="pair.value"
                    placeholder="Value"
                    class="partner-data-value"
                  ></el-input>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    class="partner-data-remove"
                    @click="fn_removePaymentUrlData(index)"
                  ></el-button>
                </div>

                <div
                  v-if="!mData.paymentUrlForm.data_pairs.length"
                  class="partner-data-empty"
                >
                  Chưa có dữ liệu. Bấm "Thêm" để nhập cặp key-value.
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <!-- Luồng API (activeStep === 2): kết quả purchase -->
        <div
          v-if="mData.activeStep === 2 && mData.selectedMethod === 'api'"
          class="step-content"
        >
          <div class="step2-header">
            <h5 class="step2-title">Kết quả purchase</h5>
            <div class="step2-actions">
              <el-button @click="fn_prevStep">Quay lại</el-button>
            </div>
          </div>

          <div v-if="mData.purchaseResult" class="step2-block">
            <el-alert
              v-if="mData.purchaseResult.success"
              title="Giao dịch purchase thành công!"
              type="success"
              show-icon
              :closable="false"
              class="mb-3"
            ></el-alert>
            <el-alert
              v-else
              :title="mData.purchaseResult.message || 'Giao dịch purchase chưa thành công'"
              type="warning"
              show-icon
              :closable="false"
              class="mb-3"
            ></el-alert>

            <div class="block-title">Dữ liệu phản hồi (JSON)</div>
            <pre class="api-response-json"><code>{{ JSON.stringify(mData.purchaseResult, null, 2) }}</code></pre>
          </div>
          <div v-else class="step2-block text-center py-5">
            <div>Chưa có kết quả purchase</div>
          </div>
        </div>

        <!-- Luồng WebView (activeStep === 2): kết quả create_payment_url -->
        <div
          v-if="mData.activeStep === 2 && mData.selectedMethod === 'webview'"
          class="payment-url-screen"
        >
          <div class="step2-header">
            <h5 class="step2-title">Kết quả tạo payment url</h5>
            <div class="step2-actions">
              <el-button @click="fn_prevStep">Quay lại</el-button>
              <el-button
                v-if="mData.paymentUrlResult && mData.paymentUrlResult.url"
                type="primary"
                plain
                icon="el-icon-top-right"
                @click="fn_openPaymentUrl"
              >
                Mở tab mới
              </el-button>
            </div>
          </div>

          <div
            v-if="mData.paymentUrlResult"
            class="payment-url-layout"
          >
            <!-- Cột trái: dữ liệu phản hồi để theo dõi -->
            <div class="payment-url-info">
              <div
                v-if="
                  mData.sessionPaymentStatus === 'new' ||
                  mData.sessionPaymentStatus === 'paying' ||
                  mData.sessionPaymentStatus === 'paid'
                "
                class="payment-status-row"
              >
                Trạng thái thanh toán:
                <el-tag
                  :type="fn_getPaymentStatusTagType(mData.sessionPaymentStatus)"
                  effect="dark"
                  class="payment-status-tag"
                >
                  {{ mData.sessionPaymentStatus }}
                </el-tag>
              </div>
              <div class="block-title">Dữ liệu phản hồi (JSON)</div>
              <pre class="api-response-json"><code>{{ JSON.stringify(mData.paymentUrlResult, null, 2) }}</code></pre>
            </div>

            <!-- Cột phải: iframe trang thanh toán -->
            <div class="payment-url-frame">
              <div v-if="mData.paymentUrlResult.url" class="payment-url-iframe-wrap">
                <iframe
                  :src="mData.paymentUrlResult.url"
                  class="payment-url-iframe"
                  frameborder="0"
                  allow="payment"
                ></iframe>
              </div>
              <div v-else class="payment-url-empty">
                <div>Không có URL thanh toán trong kết quả</div>
              </div>
            </div>
          </div>
          <div v-else class="step2-block text-center py-5">
            <div>Chưa có kết quả tạo payment url</div>
          </div>
        </div>

        <!-- Luồng QR (activeStep === 2): Màn hiển thị mã QR -->
        <div
          v-if="mData.activeStep === 2 && mData.selectedMethod === 'qr'"
          class="step-content"
        >
          <div class="step2-header">
            <h5 class="step2-title">Mã QR thanh toán</h5>
            <div class="step2-actions">
              <el-button @click="fn_prevStep">Quay lại</el-button>
            </div>
          </div>

          <div
            v-if="mData.createQrResult && mData.createQrResult.qr_code"
            class="step2-block"
          >
            <div class="qr-result">
              <div class="qr-result__image">
                <img
                  :src="fn_getQrImageSrc(mData.createQrResult.qr_code)"
                  alt="Mã QR thanh toán"
                />
              </div>

              <div class="qr-result__info">
                <div
                  v-if="
                    mData.sessionPaymentStatus === 'new' ||
                    mData.sessionPaymentStatus === 'paying' ||
                    mData.sessionPaymentStatus === 'paid'
                  "
                  class="qr-result__status"
                >
                  <span class="qr-result__status-label">
                    Trạng thái thanh toán
                  </span>
                  <el-tag
                    :type="fn_getPaymentStatusTagType(mData.sessionPaymentStatus)"
                    effect="dark"
                    class="payment-status-tag"
                  >
                    {{ mData.sessionPaymentStatus }}
                  </el-tag>
                </div>

                <div
                  v-if="mData.createQrResult.transaction_id"
                  class="qr-result__row"
                >
                  <span class="qr-result__label">Mã giao dịch</span>
                  <span class="qr-result__value">
                    {{ mData.createQrResult.transaction_id }}
                  </span>
                </div>
                <div
                  v-if="mData.createQrResult.alias_account_no"
                  class="qr-result__row"
                >
                  <span class="qr-result__label">Số TK định danh</span>
                  <span class="qr-result__value">
                    {{ mData.createQrResult.alias_account_no }}
                  </span>
                </div>
                <div
                  v-if="mData.createQrResult.session_id"
                  class="qr-result__row"
                >
                  <span class="qr-result__label">Session ID</span>
                  <span class="qr-result__value qr-result__value--mono">
                    {{ mData.createQrResult.session_id }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="step2-block">
            <div class="qr-result__empty">
              <i class="el-icon-picture-outline"></i>
              <div>Chưa có dữ liệu mã QR</div>
            </div>
          </div>
        </div>
        </div>

        <!-- Màn Tài khoản khách -->
        <div v-if="mData.entryMode === 'guest'" class="guest-scroll-area">
          <div class="step2-header">
            <h5 class="step2-title">
              <template v-if="mData.guestStep === 'order'">
                Tạo order (tài khoản khách)
              </template>
              <template v-else-if="mData.guestStep === 'method'">
                Chọn phương thức
              </template>
              <template v-else-if="mData.guestStep === 'result'">
                Mã QR thanh toán
              </template>
            </h5>
            <div class="step2-actions">
              <el-button @click="fn_guestBack">Quay lại</el-button>
              <el-button
                v-if="mData.guestStep === 'order'"
                type="primary"
                :loading="mData.creatingGuestOrder"
                @click="fn_submitGuestOrder"
              >
                Tạo order
              </el-button>
            </div>
          </div>

          <!-- Màn con 1: form tạo order -->
          <div v-if="mData.guestStep === 'order'" class="step2-block">
            <el-form
              :model="mData.guestForm"
              :rules="mData.guestRules"
              ref="guestForm"
              label-position="top"
            >
              <el-form-item label="Order ID" prop="order_id">
                <div class="order-id-row">
                  <el-input
                    v-model="mData.guestForm.order_id"
                    placeholder="Nhập hoặc tạo tự động"
                    clearable
                    class="order-id-input"
                  ></el-input>
                  <el-button
                    type="primary"
                    plain
                    class="order-id-gen"
                    @click="fn_generateGuestOrderId"
                  >
                    Tạo ID
                  </el-button>
                </div>
              </el-form-item>

              <b-row>
                <b-col md="6">
                  <el-form-item label="Merchant Code" prop="merchant_code">
                    <el-input
                      v-model="mData.guestForm.merchant_code"
                      placeholder="Mã merchant (vd: VMWEB)"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="6">
                  <el-form-item label="Merchant ID" prop="merchant_id">
                    <el-input
                      v-model="mData.guestForm.merchant_id"
                      placeholder="ID của merchant"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>

              <el-form-item label="Amount" prop="amount">
                <el-input-number
                  v-model="mData.guestForm.amount"
                  :min="0"
                  :controls="false"
                  placeholder="Nhập số tiền"
                  class="full-width"
                ></el-input-number>
              </el-form-item>

              <el-form-item label="Message" prop="message">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="mData.guestForm.message"
                  placeholder="Mô tả order"
                ></el-input>
              </el-form-item>

              <el-form-item>
                <div class="partner-data-header">
                  <span>Dữ liệu mở rộng (partner_data)</span>
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    icon="el-icon-plus"
                    @click="fn_addGuestPartnerData"
                  >
                    Thêm
                  </el-button>
                </div>

                <div
                  v-for="(pair, index) in mData.guestForm.partner_data"
                  :key="index"
                  class="partner-data-row"
                >
                  <el-input
                    v-model="pair.key"
                    placeholder="Key (vd: ticket_code)"
                    class="partner-data-key"
                  ></el-input>
                  <el-input
                    v-model="pair.value"
                    placeholder="Value"
                    class="partner-data-value"
                  ></el-input>
                  <el-button
                    type="danger"
                    plain
                    icon="el-icon-delete"
                    class="partner-data-remove"
                    @click="fn_removeGuestPartnerData(index)"
                  ></el-button>
                </div>

                <div
                  v-if="!mData.guestForm.partner_data.length"
                  class="partner-data-empty"
                >
                  Chưa có thông tin. Bấm "Thêm" để nhập dữ liệu.
                </div>
              </el-form-item>
            </el-form>

            <!-- Tạo signature cho pmt_order (giao diện giữ nguyên) -->
            <Signature
              ref="guestOrderSignatureRef"
              :is-embedded="true"
              :payload="{
                order_id: mData.guestForm.order_id,
                merchant_id: mData.guestForm.merchant_id || undefined,
                message: mData.guestForm.message || undefined,
                amount: mData.guestForm.amount,
                partner_data: fn_buildGuestPartnerDataObject(),
              }"
            />
          </div>

          <!-- Màn con 2: chọn phương thức QR / API / WebView -->
          <div
            v-else-if="mData.guestStep === 'method'"
            class="step-content"
          >
            <b-row class="justify-content-center">
              <b-col md="4">
                <div
                  class="method-block method-block--qr"
                  :class="{ 'is-active': mData.guestMethod === 'qr' }"
                  @click="mData.guestMethod = 'qr'"
                >
                  <i class="method-icon el-icon-full-screen"></i>
                  <div class="method-name">QR</div>
                  <div class="method-desc">Thanh toán qua mã QR</div>

                  <div class="qr-paygate" @click.stop>
                    <div class="qr-paygate-label">Paygate ID</div>
                    <el-input
                      v-model="mData.guestPaygateId"
                      placeholder="Nhập paygate_id"
                      clearable
                      size="small"
                      :class="{ 'is-error': mData.guestPaygateError }"
                      @input="mData.guestPaygateError = false"
                    ></el-input>
                    <div v-if="mData.guestPaygateError" class="qr-paygate-error">
                      Vui lòng nhập paygate_id
                    </div>
                    <el-button
                      type="primary"
                      size="small"
                      class="qr-paygate-btn"
                      :loading="mData.creatingQr"
                      @click="fn_guestCreateQr"
                    >
                      Tạo mã thanh toán
                    </el-button>
                  </div>
                </div>
              </b-col>
              <b-col md="4">
                <div
                  class="method-block"
                  :class="{ 'is-active': mData.guestMethod === 'api' }"
                  @click="fn_guestSelectMethod('api')"
                >
                  <i class="method-icon el-icon-connection"></i>
                  <div class="method-name">API</div>
                  <div class="method-desc">Tích hợp trực tiếp qua API</div>
                </div>
              </b-col>
              <b-col md="4">
                <div
                  class="method-block"
                  :class="{ 'is-active': mData.guestMethod === 'webview' }"
                  @click="fn_guestSelectMethod('webview')"
                >
                  <i class="method-icon el-icon-monitor"></i>
                  <div class="method-name">WebView</div>
                  <div class="method-desc">Tích hợp qua trang WebView</div>
                </div>
              </b-col>
            </b-row>
          </div>

          <!-- Màn con 3: hiển thị QR thanh toán -->
          <div
            v-else-if="mData.guestStep === 'result'"
            class="step2-block text-center"
          >
            <div
              v-if="mData.createQrResult && mData.createQrResult.qr_code"
              class="qr-result"
            >
              <div class="qr-result__image">
                <img
                  :src="fn_getQrImageSrc(mData.createQrResult.qr_code)"
                  alt="Mã QR thanh toán"
                />
              </div>

              <div class="qr-result__info">
                <div
                  v-if="
                    mData.sessionPaymentStatus === 'new' ||
                    mData.sessionPaymentStatus === 'paying' ||
                    mData.sessionPaymentStatus === 'paid'
                  "
                  class="qr-result__status"
                >
                  <span class="qr-result__status-label">
                    Trạng thái thanh toán
                  </span>
                  <el-tag
                    :type="fn_getPaymentStatusTagType(mData.sessionPaymentStatus)"
                    effect="dark"
                    class="payment-status-tag"
                  >
                    {{ mData.sessionPaymentStatus }}
                  </el-tag>
                </div>

                <div
                  v-if="mData.createQrResult.transaction_id"
                  class="qr-result__row"
                >
                  <span class="qr-result__label">Mã giao dịch</span>
                  <span class="qr-result__value">
                    {{ mData.createQrResult.transaction_id }}
                  </span>
                </div>
                <div
                  v-if="mData.createQrResult.alias_account_no"
                  class="qr-result__row"
                >
                  <span class="qr-result__label">Số TK định danh</span>
                  <span class="qr-result__value">
                    {{ mData.createQrResult.alias_account_no }}
                  </span>
                </div>
                <div
                  v-if="mData.createQrResult.session_id"
                  class="qr-result__row"
                >
                  <span class="qr-result__label">Session ID</span>
                  <span class="qr-result__value qr-result__value--mono">
                    {{ mData.createQrResult.session_id }}
                  </span>
                </div>
              </div>
            </div>
            <div v-else class="qr-result__empty">
              <i class="el-icon-picture-outline"></i>
              <div>Chưa có dữ liệu mã QR</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mushroom from "../../../service/api/dulich-api";
import { Filter } from "mushroomjs";
import AuthService from "../../../service/AuthService";
import SignatureService from "../../../service/SignatureService";
import GenerateSignature from "./GenerateSignature";
export default {
  components: {
    GenerateSignature,
    Signature: GenerateSignature,
  },
  data() {
    return {
      sessionStatusInterval: null,
      // Chu kỳ gọi lại API kiểm tra trạng thái phiên thanh toán (ms)
      sessionStatusPollInterval: 5000,
      mData: {
        entryMode: "gate", // 'gate' | 'wizard'
        gateChoice: "", // 'account' | 'guest'
        loggingIn: false,
        loginForm: {
          account: "",
          password: "",
        },
        loginRules: {
          account: [
            {
              required: true,
              message: "Vui lòng nhập tài khoản",
              trigger: "blur",
            },
          ],
          password: [
            {
              required: true,
              message: "Vui lòng nhập mật khẩu",
              trigger: "blur",
            },
          ],
        },
        activeStep: 0,
        selectedMethod: "", // 'qr' | 'api'
        merchantCode: "",
        merchantId: "",
        paygateLoaded: false,
        loadingPaygate: false,
        paygateList: [],
        selectedPaygateId: "",
        createQrResult: null,
        sessionPaymentStatus: "",
        orderId: "",
        lastCreatedOrderId: "",
        creatingOrder: false,
        creatingQr: false,
        generatedSignature: "",
        orderForm: {
          order_id: "",
          message: "",
          amount: 0,
          partner_data: [{ key: "ticket_code", value: "01" }],
        },
        // Luồng API: form purchase (sau khi tạo order)
        showPurchaseStep: false,
        callingPurchase: false,
        purchaseResult: null,
        purchaseForm: {
          session_id: "",
          amount: 0,
          description: "",
          data_pairs: [],
        },
        purchaseRules: {
          amount: [
            {
              required: true,
              message: "Vui lòng nhập số tiền",
              trigger: "blur",
            },
          ],
        },
        // Luồng WebView: form create_payment_url (sau khi tạo order)
        showPaymentUrlStep: false,
        callingPaymentUrl: false,
        paymentUrlResult: null,
        paymentUrlForm: {
          session_id: "",
          original_amount: null,
          amount: 0,
          description: "",
          data_pairs: [],
        },
        paymentUrlRules: {
          amount: [
            {
              required: true,
              message: "Vui lòng nhập số tiền",
              trigger: "blur",
            },
          ],
        },
        // Luồng tài khoản khách: tạo pmt_order với toàn bộ trường
        creatingGuestOrder: false,
        guestStep: "order", // 'order' | 'method' | 'signature'
        guestOrderId: "",
        guestMethod: "", // 'qr' | 'api' | 'webview'
        guestPaygateId: "", // paygate_id cho create_qr (nhập trong block QR)
        guestPaygateError: false,
        guestSigConfig: null, // cấu hình ký lưu từ bước pmt_order, tái dùng cho create_qr & get_status
        guestForm: {
          order_id: "",
          merchant_code: "",
          merchant_id: "",
          message: "",
          amount: 0,
          partner_data: [{ key: "ticket_code", value: "01" }],
        },
        guestRules: {
          order_id: [
            {
              required: true,
              message: "Vui lòng nhập Order ID",
              trigger: "submit",
            },
          ],
          merchant_code: [
            {
              required: true,
              message: "Vui lòng nhập Merchant Code",
              trigger: "submit",
            },
          ],
          merchant_id: [
            {
              required: true,
              message: "Vui lòng nhập Merchant ID",
              trigger: "submit",
            },
          ],
          message: [
            {
              required: true,
              message: "Vui lòng nhập Message",
              trigger: "submit",
            },
          ],
          amount: [
            {
              required: true,
              message: "Vui lòng nhập số tiền",
              trigger: "submit",
            },
            {
              type: "number",
              min: 0,
              message: "Số tiền phải lớn hơn hoặc bằng 0",
              trigger: "submit",
            },
          ],
        },
        // Màn tạo signature (bước phụ sau form order)
        showSignatureStep: false,
        showSignatureAdvanced: false,
        signatureForm: {
          secretKey: "",
          algorithm: "SHA-512",
          separator: "|",
          outputFormat: "hex-lower",
        },
        signatureRules: {
          secretKey: [
            {
              required: true,
              message: "Vui lòng nhập Secret Key",
              trigger: "submit",
            },
          ],
        },
        orderRules: {
          // trigger "submit" không phải sự kiện tự động của Element UI,
          // nên rule chỉ chạy khi gọi validate() thủ công (lúc bấm Tiếp theo)
          order_id: [
            {
              required: true,
              message: "Vui lòng nhập Order ID",
              trigger: "submit",
            },
          ],
          amount: [
            {
              required: true,
              message: "Vui lòng nhập số tiền",
              trigger: "submit",
            },
            {
              type: "number",
              min: 0,
              message: "Số tiền phải lớn hơn hoặc bằng 0",
              trigger: "submit",
            },
          ],
        },
      },
    };
  },
  computed: {
    isPaygateSelected() {
      return !!this.mData.selectedPaygateId;
    },
  },
  watch: {
    "mData.merchantCode"(newVal) {
      if (!newVal || !newVal.trim()) {
        this.fn_clearPaygateList();
      }
    },
  },
  beforeDestroy() {
    if (this.sessionStatusInterval) {
      clearInterval(this.sessionStatusInterval);
      this.sessionStatusInterval = null;
    }
  },
  methods: {
    fn_selectGate(choice) {
      this.mData.gateChoice = choice;
      if (choice === "guest") {
        this.mData.entryMode = "guest";
      }
    },
    fn_backToGate() {
      if (typeof this.fn_stopPollingSessionStatus === "function") {
        this.fn_stopPollingSessionStatus();
      }
      this.mData.sessionPaymentStatus = "";
      this.mData.entryMode = "gate";
      this.mData.gateChoice = "";
      // reset trạng thái wizard về mặc định
      this.mData.activeStep = 0;
      this.mData.selectedMethod = "";
      this.mData.showSignatureStep = false;
      this.mData.showPurchaseStep = false;
      this.mData.purchaseResult = null;
      this.mData.showPaymentUrlStep = false;
      this.mData.paymentUrlResult = null;
      // reset trạng thái luồng khách
      this.mData.guestStep = "order";
      this.mData.guestMethod = "";
      this.mData.guestOrderId = "";
      this.mData.guestPaygateId = "";
      this.mData.guestPaygateError = false;
    },
    // Quay lại trong luồng khách: result -> signature -> method -> order -> gate
    fn_guestBack() {
      if (this.mData.guestStep === "result") {
        if (typeof this.fn_stopPollingSessionStatus === "function") {
          this.fn_stopPollingSessionStatus();
        }
        this.mData.sessionPaymentStatus = "";
        this.mData.guestStep = "method";
        return;
      }
      if (this.mData.guestStep === "method") {
        this.mData.guestStep = "order";
        return;
      }
      this.fn_backToGate();
    },
    fn_guestSelectMethod(method) {
      // API / WebView: tạm dừng
      this.mData.guestMethod = method;
      window.toastr.warning(
        `Luồng tài khoản khách sử dụng phương thức ${method.toUpperCase()} chưa được hỗ trợ.`
      );
    },
    // Bấm nút "Tạo mã thanh toán" trong block QR
    fn_guestCreateQr() {
      this.mData.guestMethod = "qr";
      if (!(this.mData.guestPaygateId || "").trim()) {
        this.mData.guestPaygateError = true;
        return;
      }
      this.mData.guestPaygateError = false;
      this.fn_createGuestQrFlow();
    },
    // Ký payload bằng cấu hình đã lưu ở bước pmt_order (dùng cho create_qr & get_status)
    async fn_signGuestPayload(payload) {
      const cfg = this.mData.guestSigConfig || {};
      const formatMap = {
        "hex-lower": "HEX-LOWERCASE",
        "hex-upper": "HEX-UPPERCASE",
        base64: "Base64",
        base64url: "Base64 URL",
      };
      return await SignatureService.sign(payload, cfg.secretKey, {
        algorithm: cfg.algorithm,
        separator: cfg.separator,
        outputFormat: formatMap[cfg.outputFormat],
      });
    },
    async fn_createGuestQrFlow() {
      const merchant = (this.mData.guestForm.merchant_code || "").trim();
      const refId = this.mData.guestOrderId;
      const description = this.mData.guestForm.message || undefined;
      const paygateId = (this.mData.guestPaygateId || "").trim() || undefined;
      const partnerData = this.fn_buildGuestPartnerDataObject();
      this.mData.creatingQr = true;
      try {
        // Sinh signature mới cho đúng body create_qr
        const signature = await this.fn_signGuestPayload({
          merchant: merchant,
          ref_id: refId,
          description: description,
          paygate_id: paygateId,
          data: partnerData,
        });
        const createQrBody = {
          merchant: merchant,
          ref_id: refId,
          description: description,
          paygate_id: paygateId,
          data: partnerData,
          signature: signature,
        };
        const createQrRes = await mushroom.pmt_session.create_qrAsync({
          body: createQrBody,
        });
        this.mData.createQrResult = createQrRes.result || null;
        window.toastr.success("Tạo QR thành công");
        this.mData.guestStep = "result";
        const sessionId =
          this.mData.createQrResult && this.mData.createQrResult.session_id;
        if (sessionId) {
          // Luồng khách: check trạng thái qua get_status
          this.fn_startPollingGuestStatus(sessionId);
        }
      } catch (e) {
        console.error("[create_qr] (guest) Có lỗi: %o", e);
        if (this.fn_isInvalidSignatureError(e)) {
          window.toastr.error("Signature không hợp lệ");
        } else {
          window.toastr.error("Tạo QR không thành công: " + (e.message || ""));
        }
      } finally {
        this.mData.creatingQr = false;
      }
    },
    fn_generateGuestOrderId() {
      this.mData.guestForm.order_id = this.fn_randomObjectId();
    },
    fn_addGuestPartnerData() {
      this.mData.guestForm.partner_data.push({ key: "", value: "" });
    },
    fn_removeGuestPartnerData(index) {
      this.mData.guestForm.partner_data.splice(index, 1);
    },
    async fn_submitGuestOrder() {
      const valid = await new Promise((resolve) => {
        this.$refs.guestForm.validate((isValid) => resolve(isValid));
      });
      if (!valid) return;

      // Sinh signature cho pmt_order (bắt buộc nhập secret key)
      const sigRef = this.$refs.guestOrderSignatureRef;
      if (!sigRef) return;
      const signature = await sigRef.getSignature();
      if (!signature) return;
      // Lưu lại cấu hình ký để tái sử dụng cho create_qr và get_status
      this.mData.guestSigConfig = {
        secretKey: sigRef.secretKey,
        algorithm: sigRef.algorithm,
        separator: sigRef.separator,
        outputFormat: sigRef.outputFormat,
      };

      const partnerData = {};
      this.mData.guestForm.partner_data.forEach((pair) => {
        const key = (pair.key || "").trim();
        if (key) partnerData[key] = pair.value;
      });

      this.mData.creatingGuestOrder = true;
      try {
        const newOrder = {
          order_id: this.mData.guestForm.order_id,
          merchant_id: this.mData.guestForm.merchant_id || undefined,
          message: this.mData.guestForm.message || undefined,
          amount: this.mData.guestForm.amount,
          partner_data: partnerData,
          signature: signature,
        };
        // Truyền mã merchant (vd: VMWEB) vào header, chỉ áp dụng luồng khách
        const orderRes = await mushroom.pmt_order.createAsync(newOrder, {
          extra: {
            headers: {
              Merchant: (this.mData.guestForm.merchant_code || "").trim(),
            },
          },
        });
        window.toastr.success("Tạo order thành công. ID: " + orderRes.result);
        // Lưu id order và sang màn chọn phương thức (3 block)
        this.mData.guestOrderId = orderRes.result;
        this.mData.guestStep = "method";
      } catch (e) {
        console.error("[pmt_order.create] (guest) Có lỗi: %o", e);
        window.toastr.error(this.fn_getOrderErrorMessage(e));
      } finally {
        this.mData.creatingGuestOrder = false;
      }
    },
    fn_login() {
      this.$refs["loginForm"].validate((valid) => {
        if (!valid) return;
        this.mData.loggingIn = true;
        AuthService.one_login(
          this.mData.loginForm.account,
          this.mData.loginForm.password
        )
          .then(() => {
            this.mData.loggingIn = false;
            // Đăng nhập thành công: vào wizard 3 step
            this.mData.entryMode = "wizard";
          })
          .catch((e) => {
            console.error("[login] Có lỗi: %o", e);
            this.mData.loggingIn = false;
            window.toastr.error("Đăng nhập không thành công");
          });
      });
    },
    async fn_nextStep() {
      // Từ step 1 sang step 2: đã chọn cổng thanh toán
      if (this.mData.activeStep === 0) {
        if (!this.isPaygateSelected) return;

        const selectedPaygate = this.fn_getSelectedPaygate();
        const method = (
          selectedPaygate && selectedPaygate.method
            ? selectedPaygate.method
            : ""
        ).toLowerCase();

        // QR, API, WebView đều dùng chung luồng tạo pmt_order
        if (method === "qr" || method === "api" || method === "webview") {
          this.mData.selectedMethod = method;
          this.mData.activeStep += 1;
          return;
        }

        const methodName = method || "khác";
        window.toastr.warning(`Method đang chọn là ${methodName}`);
        return;
      }

      // Ở step 2: form thông tin order (chung cho QR và API)
      if (this.mData.activeStep === 1) {
        const valid = await new Promise((resolve) => {
          this.$refs.orderForm.validate((isValid) => resolve(isValid));
        });
        if (!valid) return; // thiếu trường bắt buộc: dừng, hiện lỗi validate

        const ok = await this.fn_createOrder();
        if (!ok) return;

        // QR: màn signature. API: màn purchase. WebView: màn create_payment_url
        if (this.mData.selectedMethod === "api") {
          this.mData.purchaseForm.amount = this.mData.orderForm.amount;
          this.mData.showPurchaseStep = true;
        } else if (this.mData.selectedMethod === "webview") {
          this.mData.paymentUrlForm.amount = this.mData.orderForm.amount;
          this.mData.showPaymentUrlStep = true;
        } else {
          this.mData.showSignatureStep = true;
        }
        return;
      }

      this.mData.activeStep += 1;
    },
    // Luồng API: gọi pmt_sessions/purchase với ref_id = id order vừa tạo
    async fn_submitPurchase() {
      const valid = await new Promise((resolve) => {
        this.$refs.purchaseForm.validate((isValid) => resolve(isValid));
      });
      if (!valid) return;

      const dataObj = {};
      this.mData.purchaseForm.data_pairs.forEach((pair) => {
        const key = (pair.key || "").trim();
        if (key) dataObj[key] = pair.value;
      });

      this.mData.callingPurchase = true;
      try {
        const purchaseBody = {
          merchant: this.mData.merchantCode,
          amount: Number(this.mData.purchaseForm.amount) || 0,
          ref_id: this.mData.orderId,
          paygate_id: this.mData.selectedPaygateId || undefined,
        };
        if (this.mData.purchaseForm.session_id) {
          purchaseBody.session_id = this.mData.purchaseForm.session_id.trim();
        }
        if (this.mData.purchaseForm.description) {
          purchaseBody.description = this.mData.purchaseForm.description.trim();
        }
        if (Object.keys(dataObj).length > 0) {
          purchaseBody.data = dataObj;
        }

        const res = await mushroom.pmt_session.purchaseAsync({
          body: purchaseBody,
        });
        const result = res && res.result ? res.result : res;
        this.mData.purchaseResult = result;

        if (result && result.success === false) {
          window.toastr.warning(
            result.message || "Giao dịch purchase không thành công"
          );
        } else {
          window.toastr.success("Gọi purchase thành công");
        }
        this.mData.showPurchaseStep = false;
        this.mData.activeStep = 2;
      } catch (e) {
        console.error("[pmt_sessions/purchase] Có lỗi: %o", e);
        window.toastr.error("Gọi purchase không thành công");
      } finally {
        this.mData.callingPurchase = false;
      }
    },
    fn_addPurchaseData() {
      this.mData.purchaseForm.data_pairs.push({ key: "", value: "" });
    },
    fn_removePurchaseData(index) {
      this.mData.purchaseForm.data_pairs.splice(index, 1);
    },
    // Luồng WebView: gọi pmt_sessions/create_payment_url với ref_id = id order
    async fn_submitPaymentUrl() {
      const valid = await new Promise((resolve) => {
        this.$refs.paymentUrlForm.validate((isValid) => resolve(isValid));
      });
      if (!valid) return;

      const dataObj = {};
      this.mData.paymentUrlForm.data_pairs.forEach((pair) => {
        const key = (pair.key || "").trim();
        if (key) dataObj[key] = pair.value;
      });

      this.mData.callingPaymentUrl = true;
      try {
        const body = {
          merchant: this.mData.merchantCode,
          amount: Number(this.mData.paymentUrlForm.amount) || 0,
          ref_id: this.mData.orderId,
          paygate_id: this.mData.selectedPaygateId || undefined,
        };
        if (this.mData.paymentUrlForm.session_id) {
          body.session_id = this.mData.paymentUrlForm.session_id.trim();
        }
        if (
          this.mData.paymentUrlForm.original_amount !== null &&
          this.mData.paymentUrlForm.original_amount !== "" &&
          this.mData.paymentUrlForm.original_amount !== undefined
        ) {
          body.original_amount =
            Number(this.mData.paymentUrlForm.original_amount) || 0;
        }
        if (this.mData.paymentUrlForm.description) {
          body.description = this.mData.paymentUrlForm.description.trim();
        }
        if (Object.keys(dataObj).length > 0) {
          body.data = dataObj;
        }

        const res = await mushroom.pmt_session.create_payment_urlAsync({
          body: body,
        });
        const result = res && res.result ? res.result : res;
        this.mData.paymentUrlResult = result;
        window.toastr.success("Tạo payment url thành công");
        this.mData.showPaymentUrlStep = false;
        this.mData.activeStep = 2;
        // Bắt đầu theo dõi trạng thái phiên thanh toán
        const sessionId = result && result.session_id;
        if (sessionId) {
          this.fn_startPollingSessionStatus(sessionId);
        }
      } catch (e) {
        console.error("[pmt_sessions/create_payment_url] Có lỗi: %o", e);
        window.toastr.error(
          (e && e.detail) || "Tạo payment url không thành công"
        );
      } finally {
        this.mData.callingPaymentUrl = false;
      }
    },
    fn_openPaymentUrl() {
      const url =
        this.mData.paymentUrlResult && this.mData.paymentUrlResult.url;
      if (url) window.open(url, "_blank", "noopener");
    },
    fn_addPaymentUrlData() {
      this.mData.paymentUrlForm.data_pairs.push({ key: "", value: "" });
    },
    fn_removePaymentUrlData(index) {
      this.mData.paymentUrlForm.data_pairs.splice(index, 1);
    },
    fn_getSelectedPaygateLabel() {
      const p = this.fn_getSelectedPaygate();
      if (!p) return "";
      return (p.code ? p.code + " - " : "") + (p.name || "");
    },
    // Màn Tạo Signature: sinh signature từ component Signature + gọi API create_qr, rồi sang step 3
    async fn_submitSignature() {
      if (!this.$refs.signatureRef) return;
      const signature = await this.$refs.signatureRef.getSignature();
      if (!signature) return;

      const ok = await this.fn_createQrFlowWithSignature(signature);
      if (!ok) return; // có lỗi API thì giữ nguyên ở màn signature
      this.mData.showSignatureStep = false;
      this.mData.activeStep += 1;
    },
    async fn_createOrder() {
      if (
        this.mData.orderId &&
        this.mData.lastCreatedOrderId === this.mData.orderForm.order_id
      ) {
        return true;
      }

      let merchantId = this.mData.merchantId;
      if (!merchantId) {
        merchantId = await this.fn_getMerchantIdByCode();
        this.mData.merchantId = merchantId;
      }
      if (!merchantId) {
        window.toastr.error(
          "Không xác định được merchant. Vui lòng tải lại danh sách cổng thanh toán."
        );
        return false;
      }

      const partnerData = this.fn_buildPartnerDataObject();
      const newOrder = {
        order_id: this.mData.orderForm.order_id,
        merchant_id: merchantId,
        message: this.mData.orderForm.message || undefined,
        amount: this.mData.orderForm.amount,
        partner_data: partnerData,
      };

      this.mData.creatingOrder = true;
      try {
        const orderRes = await mushroom.pmt_order.createAsync(newOrder);
        const orderId = orderRes.result;
        if (!orderId) {
          window.toastr.error("Không nhận được id order mới từ máy chủ.");
          return false;
        }
        this.mData.orderId = orderId;
        this.mData.lastCreatedOrderId = this.mData.orderForm.order_id;
        return true;
      } catch (e) {
        console.error("[pmt_order.create] Có lỗi: %o", e);
        window.toastr.error(this.fn_getOrderErrorMessage(e));
        return false;
      } finally {
        this.mData.creatingOrder = false;
      }
    },
    async fn_createQrFlowWithSignature(signature) {
      const selectedPaygate = this.fn_getSelectedPaygate();
      const method = selectedPaygate
        ? (selectedPaygate.method || "").toLowerCase()
        : "";
      // QR và API đều tạo QR qua create_qr
      if (method !== "qr" && method !== "api") {
        return true;
      }

      const merchant = this.mData.merchantCode;
      const description = this.mData.orderForm.message || undefined;
      const paygateId = this.mData.selectedPaygateId || undefined;
      const orderId = this.mData.orderId;
      const partnerData = this.fn_buildPartnerDataObject();

      this.mData.creatingQr = true;
      try {
        const createQrBody = {
          merchant: merchant,
          ref_id: orderId,
          description: description,
          paygate_id: paygateId,
          data: partnerData,
          signature: signature,
        };
        const createQrRes = await mushroom.pmt_session.create_qrAsync({
          body: createQrBody,
        });
        this.mData.createQrResult = createQrRes.result || null;
        window.toastr.success("Tạo QR thành công");
        const sessionId =
          this.mData.createQrResult && this.mData.createQrResult.session_id;
        if (sessionId) {
          this.fn_startPollingSessionStatus(sessionId);
        }
        return true;
      } catch (e) {
        console.error("[create_qr] Có lỗi: %o", e);
        if (this.fn_isInvalidSignatureError(e)) {
          window.toastr.error("Signature không hợp lệ");
        } else {
          window.toastr.error("Tạo QR không thành công: " + (e.message || ""));
        }
        return false;
      } finally {
        this.mData.creatingQr = false;
      }
    },
    fn_onSignatureGenerated(data) {
      this.mData.generatedSignature = data.signature;
    },
    fn_buildGuestPartnerDataObject() {
      const partnerData = {};
      this.mData.guestForm.partner_data.forEach((pair) => {
        const key = (pair.key || "").trim();
        if (key) partnerData[key] = pair.value;
      });
      return partnerData;
    },
    fn_getSelectedPaygate() {
      return this.mData.paygateList.find(
        (p) => p.id === this.mData.selectedPaygateId
      );
    },
    async fn_getMerchantIdByCode() {
      const code = (this.mData.merchantCode || "").trim();
      if (!code) return "";
      const res = await mushroom.pmt_merchant.getAllAsync({
        fields: "id,code,name",
        filters: Filter.eq("code", code).build(),
      });
      const merchant = (res.result || [])[0];
      return merchant ? merchant.id : "";
    },
    async fn_getSignature(obj) {
      const secretKey = this.mData.signatureForm.secretKey || "";
      if (!secretKey) return "";

      const formatMap = {
        "hex-lower": "HEX-LOWERCASE",
        "hex-upper": "HEX-UPPERCASE",
        base64: "Base64",
        base64url: "Base64 URL",
      };

      return await SignatureService.sign(obj, secretKey, {
        algorithm: this.mData.signatureForm.algorithm,
        separator: this.mData.signatureForm.separator,
        outputFormat: formatMap[this.mData.signatureForm.outputFormat],
      });
    },
    fn_isDuplicateOrderError(e) {
      return e.code === 401 && e.meta && e.meta.field === "$unique_key";
    },
    // Thông báo lỗi khi tạo pmt_order
    fn_getOrderErrorMessage(e) {
      if (this.fn_isDuplicateOrderError(e)) {
        return 'Order ID đã tồn tại, vui lòng bấm "Tạo ID" để tạo Order ID mới';
      }
      // Lỗi thiếu/sai field: { code: 402, meta: { field: "..." } }
      if (e && e.code === 402 && e.meta && e.meta.field) {
        return "Trường " + e.meta.field + " không hợp lệ hoặc khai báo thiếu";
      }
      return "Tạo order không thành công";
    },
    fn_isInvalidSignatureError(e) {
      return e.code === 404 && e.meta && e.meta.field === "signature";
    },
    async fn_createQrFlow() {
      const merchant = this.mData.merchantCode;
      const description = this.mData.orderForm.message || undefined;
      const paygateId = this.mData.selectedPaygateId || undefined;
      const partnerData = this.fn_buildPartnerDataObject();

      let orderId = "";
      try {
        let merchantId = this.mData.merchantId;
        if (!merchantId) {
          merchantId = await this.fn_getMerchantIdByCode();
          this.mData.merchantId = merchantId;
        }
        if (!merchantId) {
          window.toastr.error(
            "Không xác định được merchant. Vui lòng tải lại danh sách cổng thanh toán."
          );
          return false;
        }
        const newOrder = {
          order_id: this.mData.orderForm.order_id,
          merchant_id: merchantId,
          message: this.mData.orderForm.message || undefined,
          amount: this.mData.orderForm.amount,
          partner_data: partnerData,
        };
        const orderRes = await mushroom.pmt_order.createAsync(newOrder);
        orderId = orderRes.result;
        if (!orderId) {
          console.warn("[pmt_order.create] Không nhận được id order mới");
          return false;
        }
      } catch (e) {
        console.error("[pmt_order.create] Có lỗi: %o", e);
        window.toastr.error(this.fn_getOrderErrorMessage(e));
        return false;
      }

      const selectedPaygate = this.fn_getSelectedPaygate();
      const method = selectedPaygate
        ? (selectedPaygate.method || "").toLowerCase()
        : "";
      if (method !== "qr") {
        return true;
      }

      try {
        const signature = await this.fn_getSignature({
          merchant: merchant,
          ref_id: orderId,
          description: description,
          paygate_id: paygateId,
          data: partnerData,
        });
        const createQrBody = {
          merchant: merchant,
          ref_id: orderId,
          description: description,
          paygate_id: paygateId,
          data: partnerData,
          signature: signature,
        };
        const createQrRes = await mushroom.pmt_session.create_qrAsync({
          body: createQrBody,
        });
        this.mData.createQrResult = createQrRes.result || null;
        const sessionId =
          this.mData.createQrResult && this.mData.createQrResult.session_id;
        if (sessionId) {
          this.fn_startPollingSessionStatus(sessionId);
        }
        return true;
      } catch (e) {
        console.error("[create_qr] Có lỗi: %o", e);
        if (this.fn_isInvalidSignatureError(e)) {
          window.toastr.error("Signature không hợp lệ");
        }
        return false;
      }
    },
    fn_prevStep() {
      if (this.mData.activeStep === 2) {
        if (typeof this.fn_stopPollingSessionStatus === "function") {
          this.fn_stopPollingSessionStatus();
        }
        this.mData.sessionPaymentStatus = "";
        this.mData.activeStep = 1;
        // QR -> signature, API -> purchase, WebView -> payment url
        if (this.mData.selectedMethod === "api") {
          this.mData.showPurchaseStep = true;
        } else if (this.mData.selectedMethod === "webview") {
          this.mData.showPaymentUrlStep = true;
        } else {
          this.mData.showSignatureStep = true;
        }
        return;
      }
      if (this.mData.showSignatureStep) {
        this.mData.showSignatureStep = false;
        return;
      }
      if (this.mData.showPurchaseStep) {
        this.mData.showPurchaseStep = false;
        return;
      }
      if (this.mData.showPaymentUrlStep) {
        this.mData.showPaymentUrlStep = false;
        return;
      }
      if (this.mData.activeStep > 0) this.mData.activeStep -= 1;
    },
    fn_getQrImageSrc(qrCode) {
      if (!qrCode) return "";
      if (qrCode.startsWith("data:") || qrCode.startsWith("http")) {
        return qrCode;
      }
      return "data:image/png;base64," + qrCode;
    },
    fn_addPartnerData() {
      this.mData.orderForm.partner_data.push({ key: "", value: "" });
    },
    fn_removePartnerData(index) {
      this.mData.orderForm.partner_data.splice(index, 1);
    },
    fn_buildPartnerDataObject() {
      const result = {};
      this.mData.orderForm.partner_data.forEach((pair) => {
        const key = (pair.key || "").trim();
        if (key) result[key] = pair.value;
      });
      return result;
    },
    fn_randomObjectId() {
      const hex = "0123456789abcdef";
      let id = "";
      for (let i = 0; i < 24; i++) {
        id += hex[Math.floor(Math.random() * 16)];
      }
      return id;
    },
    fn_generateOrderId() {
      this.mData.orderForm.order_id = this.fn_randomObjectId();
    },
    fn_clearPaygateList() {
      this.mData.paygateList = [];
      this.mData.selectedPaygateId = "";
      this.mData.merchantId = "";
      this.mData.paygateLoaded = false;
    },
    async fn_getPaygateList() {
      const code = (this.mData.merchantCode || "").trim();
      if (!code) {
        this.fn_clearPaygateList();
        return;
      }

      this.mData.loadingPaygate = true;
      this.mData.selectedPaygateId = "";
      this.mData.merchantId = "";
      try {
        const merchantRes = await mushroom.pmt_merchant.getAllAsync({
          fields: "id,code,name,paygate_id,paygate_ids",
          filters: Filter.eq("code", code).build(),
        });

        const firstMerchant = (merchantRes.result || [])[0];
        this.mData.merchantId = firstMerchant ? firstMerchant.id : "";

        const paygateIds = [];
        (merchantRes.result || []).forEach((merchant) => {
          (merchant.paygate_ids || []).forEach((id) => {
            if (id && paygateIds.indexOf(id) === -1) paygateIds.push(id);
          });
        });

        if (!paygateIds.length) {
          this.mData.paygateList = [];
          return;
        }

        const paygateRes = await mushroom.pmt_paygate.getAllAsync({
          fields: "id,code,name,method,order,type",
          filters: Filter.in("id", paygateIds).build(),
        });
        this.mData.paygateList = paygateRes.result || [];
      } catch (e) {
        console.error("[fn_getPaygateList] Có lỗi: %o", e);
        this.mData.paygateList = [];
      } finally {
        this.mData.paygateLoaded = true;
        this.mData.loadingPaygate = false;
      }
    },
    fn_startPollingSessionStatus(sessionId) {
      if (typeof this.fn_stopPollingSessionStatus === "function") {
        this.fn_stopPollingSessionStatus();
      }
      this.mData.sessionPaymentStatus = "";
      if (!sessionId) return;
      this.fn_checkSessionStatus(sessionId);
      this.sessionStatusInterval = setInterval(() => {
        this.fn_checkSessionStatus(sessionId);
      }, this.sessionStatusPollInterval);
    },
    async fn_checkSessionStatus(sessionId) {
      if (!sessionId) return;
      mushroom.pmt_session.invalidCache();
      try {
        const res = await mushroom.pmt_session.findByIdAsync(
          { id: sessionId }
        );
        const sessionData = res && res.result ? res.result : res;
        const status = sessionData && sessionData.payment_status;
        if (status === "new" || status === "paying" || status === "paid") {
          this.mData.sessionPaymentStatus = status;
          if (status === "paid") {
            if (typeof this.fn_stopPollingSessionStatus === "function") {
              this.fn_stopPollingSessionStatus();
            }
          }
        } else {
          if (typeof this.fn_stopPollingSessionStatus === "function") {
            this.fn_stopPollingSessionStatus();
          }
          this.mData.sessionPaymentStatus = "";
        }
      } catch (e) {
        console.error(
          "[check_status] Lỗi khi gọi pmt_session findByIdAsync: %o",
          e
        );
      }
    },
    fn_stopPollingSessionStatus() {
      if (this.sessionStatusInterval) {
        clearInterval(this.sessionStatusInterval);
        this.sessionStatusInterval = null;
      }
    },
    // Luồng khách: poll trạng thái qua pmt_sessions/get_status (cần signature)
    fn_startPollingGuestStatus(sessionId) {
      this.fn_stopPollingSessionStatus();
      this.mData.sessionPaymentStatus = "";
      if (!sessionId) return;
      this.fn_checkGuestStatus(sessionId);
      this.sessionStatusInterval = setInterval(() => {
        this.fn_checkGuestStatus(sessionId);
      }, this.sessionStatusPollInterval);
    },
    async fn_checkGuestStatus(sessionId) {
      if (!sessionId) return;
      try {
        // Sinh signature mới cho body get_status (ký { session_id })
        const signature = await this.fn_signGuestPayload({
          session_id: sessionId,
        });
        const url = mushroom.$using() + "pmt_sessions/get_status";
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-HTTP-Method-Override": "get_status",
            Merchant: (this.mData.guestForm.merchant_code || "").trim(),
          },
          body: JSON.stringify({
            session_id: sessionId,
            signature: signature,
          }),
        });
        const res = await response.json();
        const result = res && res.result ? res.result : res;
        const status = result && result.status;
        if (status === "new" || status === "paying" || status === "paid") {
          this.mData.sessionPaymentStatus = status;
          if (status === "paid") this.fn_stopPollingSessionStatus();
        } else {
          // Các trạng thái kết thúc khác (error/cancelled/timeout/refund...): dừng poll
          this.fn_stopPollingSessionStatus();
          this.mData.sessionPaymentStatus = status || "";
        }
      } catch (e) {
        console.error("[get_status] Lỗi khi gọi pmt_sessions/get_status: %o", e);
      }
    },
    fn_getPaymentStatusTagType(status) {
      if (status === "paid") return "success";
      if (status === "paying") return "warning";
      return "info";
    },
  },
};
</script>

<style lang="scss" scoped src="./MerchantTest.scss"></style>
